import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';

class SectionHeading extends Component {
  render () {
    let { subText, heading, align } = this.props;
    return (
      <Row className="le-section-heading mt-5">
        <Col md={12} className={`${align?align:''}`}>
          <p>{subText}</p>
          <h3>{heading}</h3>
          <hr align={`${align=='heading-left'?'left':'center'}`} />
        </Col>
      </Row>
    )
  }
}

export default SectionHeading;